export const PlenaMark = ({ className = "w-[18px] h-7" }) => (
  <svg viewBox="0 0 34 56" fill="none" className={className}>
    <rect x="0" y="0" width="9" height="36" rx="4.5" className="fill-[#EE6A63] dark:fill-[#F0A19C]" />
    <rect x="12.5" y="0" width="9" height="14" rx="4.5" className="fill-[#F5C64F] dark:fill-[#F5DB9C]" />
    <rect x="12.5" y="19" width="9" height="37" rx="4.5" className="fill-[#4394F0] dark:fill-[#9CC4F2]" />
    <rect x="25" y="19" width="9" height="14" rx="4.5" className="fill-[#3BC492] dark:fill-[#9BDDC4]" />
  </svg>
);

export const PlenaLogo = ({ size = "md", proje = true }) => {
  const cfg = size === "lg"
    ? { mark: "w-8 h-[52px]", word: "text-3xl", proje: "text-xs px-2.5 py-1" }
    : size === "sm"
      ? { mark: "w-[14px] h-[22px]", word: "text-base", proje: "text-[9px] px-1.5 py-0.5" }
      : { mark: "w-[17px] h-[27px]", word: "text-lg", proje: "text-[10px] px-2 py-0.5" };
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="plena-logo">
      <PlenaMark className={cfg.mark} />
      <span className={`font-display font-bold tracking-tight text-slate-900 dark:text-white leading-none ${cfg.word}`}>
        plena<span className="text-slate-400 dark:text-slate-500">.pro</span>
      </span>
      {proje && (
        <span className={`font-bold rounded-full bg-slate-900/5 dark:bg-white/10 text-slate-500 dark:text-slate-300 uppercase tracking-widest ${cfg.proje}`}>
          Proje
        </span>
      )}
    </span>
  );
};

export default PlenaLogo;
